import React from "react";
import { X } from "lucide-react";
import "../../styles/FormCard.css";

const CancelButton = ({ onClick, text = "Annuler", disabled = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="cancel-button"
    >
      <X size={18} />
      {text}
    </button>
  );
};

export default CancelButton;
